import React, { useContext, useEffect, useState } from "react";
import AlertContext from "../Contexts/AlertContext";
import { authFileRequest, fileRequest, props } from "../APIs/api";
import AuthContext from "../Contexts/AuthContext";
import AlertTypes from "../Enums/AlertTypes";
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import NavContext from "../Contexts/NavContext";
import { useNavigate } from "react-router-dom";


const ConfirmOrder = () => {

    const {currentOrder, updateCurrentOrder, openAlert} = useContext(AlertContext);
    const {isLoggedIn, cookies} = useContext(AuthContext);
    const {selectNav} = useContext(NavContext);

    const navigate = useNavigate();
    const [foundImageURL, setFoundImageURL] = useState<string>("");

    useEffect(() => {

        let imageSetter = async () => {
            if(currentOrder.form.phone_image) {
                setFoundImageURL(await readFileAsDataURL(currentOrder.form.phone_image));
            }
        };

        imageSetter();

    }, [currentOrder]);

    const submitOrder = async () => {

        try {

            let req_data: any = {
                serviceId: currentOrder.service.id,
                deviceId: currentOrder.device.id,
                imei: currentOrder.form.imei,
                problemExp: currentOrder.form.problem
            };
            let order_number = "";
            let response: any = null;
            
            if(currentOrder.form.phone_image) {
                req_data.attachmentName = "user phone image";
                req_data.attachmentFile = currentOrder.form.phone_image;
            }

            if(isLoggedIn) {
                response = await authFileRequest(cookies.login_token, "post", "crud/createOrder_Repair_User_Attachment", req_data)
            } else {

                req_data.fullName = currentOrder.form.full_name;
                req_data.phone = currentOrder.form.phone;
    
                response = await fileRequest("post", "crud/createOrder_Repair_User_Attachment", req_data);

            }
    
            openAlert(AlertTypes.Success, (<>
                Your repair order request has been sent for review. we will contact you as soon as possible. Order number {response.orderId} 
                <ContentCopyIcon
                    sx={{fontSize: 20}}
                    onClick={async () => {
                        navigator.clipboard.writeText(response.orderId.toString()).then(() => {
                            console.log('Text copied to clipboard:', response.orderId);
                        }).catch((error) => {
                            console.error('Error copying text:');
                        });
                    }}
                /> 
            </>));
            navigate("/home");
            selectNav && selectNav("home");

        } catch(error: any){
            openAlert(AlertTypes.Error, error.message); 
        }
    }

    const readFileAsDataURL = (file: any): Promise<any> => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            
            // When reading is complete, resolve the promise with the data URL
            reader.onload = () => resolve(reader.result);
    
            // If an error occurs, reject the promise
            reader.onerror = () => reject(new Error('Error reading file'));
    
            // Read the file as a Data URL
            reader.readAsDataURL(file);
        });
    }

    return (
        <div className="w-100 px-3 pt-3" style={{position: "relative"}}>
            <h5 className="card-title mb-2">Confirm Order</h5>
            <p className="lead mb-3">Please review the order detail and confirm the order using the button at the bottom.</p>
            <h5 className="card-title mb-2">Selected Device</h5>
            <div className="nuwa-card p-2 w-100 d-flex mb-3 nuwa_panel" 
                style={{borderRadius: "13px", backdropFilter: "blur(35px)", cursor: "pointer"}}
            >
                <img src={`/images/services/application 1.png`} alt="phone pic" className="rounded-2" style={{background: "black", width: "25%"}} />
                {/* <img src={`${props.baseURL}file/${currentOrder.device.picture}`} alt="phone pic" className="rounded-2" style={{width: "25%"}} /> */}
                <div className="w-100 ms-3 nuwa_group">
                    <h5 className="card-title" style={{fontSize: "18px"}}>{currentOrder.device.name}</h5>
                    <div className="lead" style={{fontSize: "11px"}} >{currentOrder.device.model}</div>
                    <div className="lead" style={{fontSize: "11px"}} >{currentOrder.form.imei}</div>
                </div>
            </div>

            <h5 className="card-title mb-2">Ordered Service</h5>
            <div className="nuwa-card p-2 w-100 d-flex mb-3 nuwa_panel" 
                style={{borderRadius: "13px", backdropFilter: "blur(35px)", cursor: "pointer"}}
            >
                {/* <img src={`/images/devices/galaxy_core_prime.png`} alt="phone pic" className="rounded-2" style={{width: "25%"}} /> */}
                <img src={`${props.baseURL}file/${currentOrder.service.picture}`} alt="phone pic" className="rounded-2" style={{width: "25%"}} />
                <div className="w-100 ms-3 nuwa_group">
                    <h5 className="card-title" style={{fontSize: "18px"}}>{currentOrder.service.title}</h5>
                    <span className="lead text-center" style={{fontSize: "11px"}} >{currentOrder.service.description.substring(0, 50)}...</span>
                </div>
            </div>

            <h5 className="card-title mb-2">Problem Description</h5>
            <p className="lead fs-6"> {currentOrder.form.problem} </p>
            
            <h5 className="card-title mb-2">Account Information</h5>
            <div className="nuwa-card p-2 w-100 d-flex mb-3 nuwa_panel" 
                style={{borderRadius: "13px", backdropFilter: "blur(35px)", cursor: "pointer"}}
            >
                FullName: {currentOrder.form.full_name}<br/>
                Phone Number: {currentOrder.form.phone}<br/>
            </div>

            {currentOrder.form.phone_image ? (
                <div className="w-100">
                    <h5 className="card-title mb-2">Attached Image</h5>
                    <div className="nuwa-card p-2 w-100 d-flex mb-3 nuwa_panel" 
                        style={{borderRadius: "13px", backdropFilter: "blur(35px)", cursor: "pointer"}}
                    >
                        <img src={foundImageURL} alt="phone pic" className="rounded-2" style={{width: "100%"}} />
                    </div>
                </div>
            ) : (<></>)}

            <button className="nuwa-white-btn py-2 px-2 text-center w-100"
                onClick={() => {
                    submitOrder();
                }}
            >
                Confirm Order
            </button>

        </div>
    );

};

export default ConfirmOrder;